import React from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import { EditSvg } from '../../../assets/svg-icon-components/EditSvg';
import { TrashSvg } from '../../../assets/svg-icon-components/TrashSvg';
import { DashboardHeader } from '../../core/DashboardHeader';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { RhButton, RhButtonMode } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { RhCardListItem } from '../../core/RhCardListItem';
import { colors } from '../../core/Styles';
import { ChurchProps } from '../containers/ChurchContainer';
import MarkdownIt from 'markdown-it';
import { IoInformationCircleOutline } from 'react-icons/io5';

const md = new MarkdownIt();

export const ChurchScreen = (props: ChurchProps) => {
  return (
    <DashboardWrapper>
      <DashboardHeader
        title="Churches"
        actions={[
          props.isLoading && <CircleSpinner key="spinner" size={20} color={colors.primary} />,
          <RhButton key="add" title="Add new church" onClick={props.userClickedAddSection} />,
        ]}
      />
      <div className="grid grid-cols-5 gap-5">
        {/* 1st column */}
        <div className="col-span-3">
          <RhCard className="space-y-5">
            {!props.churches.length &&
              (props.isLoading ? <CircleSpinner size={20} color={colors.primary} /> : <div>No sections yet</div>)}
            {props.churches.map((church, i) => (
              <RhCardListItem
                key={church.id}
                description={
                  <div
                    // The styling is defined in App.css
                    className="mission-statement"
                    dangerouslySetInnerHTML={{ __html: md.render(church.name) }}
                  />
                }
                isDescriptionTruncated={false}
                topRightActions={[
                  <RhButton
                    key="edit"
                    mode={RhButtonMode.subtle}
                    prefixSvg={EditSvg}
                    iconColor={colors.grey}
                    onClick={() => {
                      props.userClickedEditSection(church.id);
                    }}
                  />,
                  <RhButton
                    key="delete"
                    mode={RhButtonMode.subtle}
                    prefixSvg={TrashSvg}
                    iconColor={colors.grey}
                    onClick={() => {
                      props.userClickedDeleteSection(church.id);
                    }}
                  />,
                ]}
                trailing={() => <div />}
              />
            ))}
          </RhCard>
        </div>
        {/* 2nd column */}
      </div>
    </DashboardWrapper>
  );
};
